import { FC, useEffect } from 'react';
import { Button, Space, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useConfirmModal } from '@/hooks/useConfirmModal';
import type { ActionsProps } from './Actions.types';
import { APP_SCOPE, NAMESPACE, DELETE_ACTION_COLOR } from '@/constants';
import { useRole } from '@/hooks/useRole';
import { useDeleteUserMutation } from '@/api';

const Actions: FC<ActionsProps> = ({ id, edit }) => {
  const { canDelete, canUpdate } = useRole(APP_SCOPE.USER_SETTINGS);
  const { t } = useTranslation(NAMESPACE.USER_SETTINGS_PAGE);
  const [deleteUser, { isSuccess: isDeletionSuccessful }] = useDeleteUserMutation();
  const { handleConfirm: handleDeleteChannel } = useConfirmModal({
    title: t('deleteUserModalTitle'),
    content: t('deleteUserModalDescription'),
    destructive: true,
    okText: t('cancel', { ns: NAMESPACE.COMMON }),
    cancelText: t('delete', { ns: NAMESPACE.COMMON }),
    onCancel: () => deleteUser(id)
  });

  useEffect(() => {
    if (isDeletionSuccessful) {
      message.success(t('userHasBeenDeleted'));
    }
  }, [isDeletionSuccessful, t]);

  return (
    <Space size={0}>
      {canUpdate && (
        <Button onClick={edit} type="link">
          {t('edit', { ns: NAMESPACE.COMMON })}
        </Button>
      )}
      {canDelete && (
        <Button onClick={handleDeleteChannel} type="link" danger style={{ color: DELETE_ACTION_COLOR }}>
          {t('delete', { ns: NAMESPACE.COMMON })}
        </Button>
      )}
    </Space>
  );
};

export default Actions;
